__turbopack_context__.v({
  "address": "BlockLocation-module-scss-module__B3kZTa__address",
  "bgWhite": "BlockLocation-module-scss-module__B3kZTa__bgWhite",
  "blockLocation": "BlockLocation-module-scss-module__B3kZTa__blockLocation",
  "blockLocationInner": "BlockLocation-module-scss-module__B3kZTa__blockLocationInner",
  "column": "BlockLocation-module-scss-module__B3kZTa__column",
  "columnInner": "BlockLocation-module-scss-module__B3kZTa__columnInner",
  "contactEmail": "BlockLocation-module-scss-module__B3kZTa__contactEmail",
  "contactLabel": "BlockLocation-module-scss-module__B3kZTa__contactLabel",
  "contactName": "BlockLocation-module-scss-module__B3kZTa__contactName",
  "contactNumber": "BlockLocation-module-scss-module__B3kZTa__contactNumber",
  "contactWrapper": "BlockLocation-module-scss-module__B3kZTa__contactWrapper",
  "customLink": "BlockLocation-module-scss-module__B3kZTa__customLink",
  "hoursLabel": "BlockLocation-module-scss-module__B3kZTa__hoursLabel",
  "hoursList": "BlockLocation-module-scss-module__B3kZTa__hoursList",
  "hoursWrapper": "BlockLocation-module-scss-module__B3kZTa__hoursWrapper",
  "locationCard": "BlockLocation-module-scss-module__B3kZTa__locationCard",
  "logoWrapper": "BlockLocation-module-scss-module__B3kZTa__logoWrapper",
  "market": "BlockLocation-module-scss-module__B3kZTa__market",
  "menuButton": "BlockLocation-module-scss-module__B3kZTa__menuButton",
  "reservationButton": "BlockLocation-module-scss-module__B3kZTa__reservationButton",
  "textEyebrow": "BlockLocation-module-scss-module__B3kZTa__textEyebrow",
  "timeSpan": "BlockLocation-module-scss-module__B3kZTa__timeSpan",
});
